import { render } from "./FormatBold.vue?vue&type=template&id=5a4a86d8"
import script from "./FormatBold.vue?vue&type=script&lang=js"
export * from "./FormatBold.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__